import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ApplicationApi } from '@classes/application/application';
import { ClientSmartHub } from '@classes/client/client';
import { RoleApi } from '@classes/role/role';
import { AddUser, UpdateUser } from '@classes/user/userAdd';
import { UserList } from '@classes/user/userlist';
import {
  faPlus,
  faTrashAlt,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { ApplicationService } from '@services/application/application.service';
import { ClientService } from '@services/client/client.service';
import { RolesService } from '@services/roles/roles.service';
import { UiService } from '@services/ui/ui.service';
import { AddUsersComponent } from 'app/components/admin/add-users/add-users.component';

import { UserService } from '@services/user/user.service';

export interface DialogData {
  client: ClientSmartHub;
  user: UpdateUser;
  element: UpdateUser;
}

@Component({
  selector: 'app-open-dialog-edit-user',
  templateUrl: './open-dialog-edit-user.component.html',
  styleUrls: ['./open-dialog-edit-user.component.scss'],
})
export class OpenDialogEditUserComponent implements OnInit {
  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faInfo = faInfoCircle;

  EditUserForm: UntypedFormGroup;
  inactive = true;
  ArrayValueInput: string[] = [];
  confirmAdd = false;
  clients: ClientSmartHub[];
  applications: ApplicationApi[];
  roles: RoleApi[];
  appChoice: string[] = [];
  applicationsFiltered: ApplicationApi[];
  client: ClientSmartHub;
  user: UpdateUser;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    private userService: UserService,
    private clientService: ClientService,
    private applicationService: ApplicationService,
    private roleService: RolesService,
    private uiService: UiService,
    public dialogRef: MatDialogRef<OpenDialogEditUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.getAllClients();
    this.getAllApplications();
    this.getAllRoles();
    this.initForm();
  }

  onSubmit(): void {
    const client = this.clients.find((c) => c.name === this.f.client.value);
    const updateUser: UpdateUser = {
      id: this.f.id.value,
      username: this.f.username.value,
      email: this.f.email.value,
      gsm: this.f.gsm.value,
      client: client,
      applications: this.f.applications.value,
    };

    this.userService.UpdateUser(updateUser).subscribe({
      next: () => this.dialog.closeAll(),
    });
  }

  isInactive(): void {}

  getData(isNew: boolean) {
    return {
      isNew,
    };
  }

  addApplicationInput(): void {
    this.applicationControls.controls?.length < this.applications?.length
      ? this.applicationControls.push(this.createApplicationInput())
      : this.uiService.showSnackbar(
          "Vous ne pouvez plus ajouter d'application"
        );
  }

  deleteApplicationInput(index: number): void {
    this.applicationControls.removeAt(index);
  }

  filterValuesApp(index: number, app?: string): boolean {
    const appPrevious = [];

    for (let i = index; i > 0; i--) {
      const appName = this.getApplicationControlsInput(i - 1)?.value;
      appPrevious.push(appName);
    }

    return appPrevious.includes(app) ? false : true;
  }

  get f() {
    return this.EditUserForm.controls;
  }

  get applicationControls(): UntypedFormArray {
    return this.EditUserForm.controls.applications as UntypedFormArray;
  }
  getApplicationControlsInput(index: number): UntypedFormGroup {
    return this.applicationControls.controls[index]['controls']
      .applicationName as UntypedFormGroup;
  }

  private getAllClients(): void {
    this.clientService.getAllClients().subscribe({
      next: (clients) => (this.clients = clients),
    });
  }
  private getAllApplications(): void {
    this.applicationService.getAllApplications().subscribe({
      next: (applications) => {
        this.applications = applications;
        this.applicationsFiltered = applications;
      },
    });
  }
  private getAllRoles(): void {
    this.roleService.getAllRole().subscribe({
      next: (roles) => (this.roles = roles),
    });
  }

  private initForm(): void {
    this.EditUserForm = this.formBuilder.group({
      id: [this.data.element.id],
      username: [this.data.element.username, Validators.required],
      email: [this.data.element.email, Validators.required],
      gsm: [this.data.element.gsm],
      client: [this.data.element.client.name, Validators.required],
      applications: this.formBuilder.array([], Validators.required),
    });

    // this.EditUserForm.get('client').setValue(this.data.element.client.name);

    if (this.data.element.applications.length > 0) {
      this.data.element.applications.map((application) => {
        this.onAddApplication(application);
      });
    }
  }

  private createApplicationInput(): UntypedFormGroup {
    return this.formBuilder.group({
      // application: [this.data.element.applications[].application[].applicationName],
      // role: [this.data.element.applications[].role[].name]
    });
  }

  onAddApplication(app?): void {
    let application = null;
    let role = null;

    if (app) {
      application = app.application;
      role = app.role;
    }

    const newGroup = this.formBuilder.group({
      application: [application, Validators.required],
      role: [role, Validators.required],
    });

    newGroup.get('application').valueChanges.subscribe((result) => {
      if (result) {
        newGroup.get('role').reset();
      }
    });

    this.applicationControls.push(newGroup);
  }

  compareApplication(o1: any, o2: any) {
    return o1.ApplicationName == o2.ApplicationName && o1.id == o2.id;
  }

  compareRole(o1: any, o2: any) {
    return o1.name == o2.name && o1.id == o2.id;
  }
}
